import React from "react";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import Grid from "@mui/material/Grid";
import DragMiniCard from "../../../../components/drag/GragCard/DragMiniCard";

const TaskTableBox = ({
  taskvalue,
  taskIndex,
  moduleIndex,
  sprintIndex,
  milestoneIndex,
  mileStoneName,
}) => {
  return (
    <>
      <div className="tasklistColumn">
        <div className="tasktable-head">
          <ArrowRightIcon />
          <h3>{taskvalue?.tasktile}</h3>
        </div>
        <div className="tasktable-body">
        <div
  style={{
    display: "flex",
    gap: "16px",
    alignItems: "center",
    marginRight:"10px",
    flexWrap: "wrap",
  }}
>
  <p style={{ margin: 0, fontSize: "0.9rem" }}>
    <span style={{ color: "#999", fontWeight: "600" }}>Duration:</span>{" "}
    <span style={{ color: "#333", fontWeight: "400" }}>
      {taskvalue?.duartion} hr
    </span>
  </p>

  <p style={{ margin: 0, fontSize: "0.9rem" }}>
    <span style={{ color: "#999", fontWeight: "600" }}>Assigned Hours:</span>{" "}
    <span style={{ color: "#333", fontWeight: "400" }}>
      {taskvalue?.assigned_hours}
    </span>
  </p>

  <p style={{ margin: 0, fontSize: "0.9rem" }}>
    <span style={{ color: "#999", fontWeight: "600" }}>Assignee:</span>{" "}
    <span style={{ color: "#333", fontWeight: "400" }}>
      {taskvalue?.assignee_name}
    </span>
  </p>
</div>

          <DragMiniCard
            style={{
              backgroundColor:
                taskvalue?.status === "Not Started"
                  ? "#f9c0c0"
                  : taskvalue?.status === "Started"
                  ? "#ffe9a9"
                  : taskvalue?.status === "Hold"
                  ? "#bfe3f2"
                  : taskvalue?.status === "Completed"
                  ? "#b8eac5"
                  : "#f0f0f0",
            }}
          >
            {taskvalue?.status}
          </DragMiniCard>
        </div>
      </div>
    </>
  );
};

export default TaskTableBox;
